import { HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { TenantService } from "../services";
import { CurrentTenant } from "@app/core/models/CurrentTenant";
import { firstValueFrom } from "rxjs";

@Injectable({
    providedIn: "root",
  })
export class ContentLanguageComponent {
    public language: string = ""
    _headers :HttpHeaders

    constructor(private tenantService: TenantService) { 
        this.getLanguage()
    }

    get headers () {
        return this._headers            
    }

    set headers(header :HttpHeaders) {
        this._headers = header
    }

    public async getLanguage() {
        const currentTenant: CurrentTenant = await firstValueFrom(
            this.tenantService.getCurrentTenant()
        )
       return currentTenant
    }

} 